<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="v_tableData"
      :columns="tableColumns"
      :height="333"
      show-footer
      :footer-method="() => footerData"
      border
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:top>
        <div class="side-frame-success">
          <span class="side-frame-text">
            {{ $l('table_inspection_detail') || '检验明细' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            size="sm"
            variant="outline-primary"
            @click="openInspectionVisible"
            v-if="!disabled"
          >
            <i class="el-icon-plus" />
            {{ $l('INDEX.btn_add') || '新增' }}
          </b-button>
          <el-badge
            v-if="!disabled"
            :value="checkCount"
            :hidden="!checkCount"
            class="clearable-button"
            :class="{ clearable: !!checkCount }"
          >
            <b-button
              class="ml-2"
              size="sm"
              variant="outline-danger"
              :disabled="checkIsEmpty"
              @click="batchDelShare()"
              ><i class="el-icon-delete" />{{
                $l('INDEX.btn_delete') || '删除'
              }}
            </b-button>
          </el-badge>

          <b-button
            class="ml-2"
            size="sm"
            variant="outline-primary"
            @click="onImagePreview({ index: 0 })"
          >
            {{ $l('btn_preview') || '查看码单图片' }}
          </b-button>
          <b-button
            class="ml-2"
            size="sm"
            variant="outline-primary"
            @click="visible = true"
            v-if="!disabled"
          >
            {{ $l('btn_edit_image') || '编辑码单图片' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <i
            class="el-icon-view tool-btn"
            @click="openEditInspectionVisible('detail', row)"
          ></i>
          <i
            v-if="!disabled"
            class="el-icon-edit tool-btn"
            @click="openEditInspectionVisible('edit', row)"
          ></i>
          <i
            v-if="!disabled"
            class="el-icon-delete tool-btn"
            @click="del(row)"
          ></i>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>

    <EditInspectionInfo
      :title="$l('dialog_inspection_edit_title') || '编辑检验信息'"
      :visible.sync="editInspectionOption.inspectionVisible"
      :disabled="editInspectionOption.disabled"
      :inspectionDetailCode="editInspectionOption.inspectionDetailCode"
      :inspectionCode="inspectionCode"
      :totalArrivalQuantity="totalArrivalQuantity"
      @close="close"
      @setTableData="setTableData"
    />
    <SampleImage
      v-if="visible"
      @closeImage="closeImage"
      :visible="visible"
      :inspectionCode="inspectionCode"
      :imageList.sync="v_imageList"
      :title="$l('dialog_upload_image_title') || '上传码单图片'"
    />
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="(item, index) in previewSrcs"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="index"
      />
    </div>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditInspectionInfo from '../edit-inspection-info/drawer.vue'
import EditLoading from '@/mixins/edit-loading'
import {
  divideDown,
  subtract,
  multiply,
  add,
  format,
} from '@/libs/util.number.js'
import SampleImage from '../sample-image'
import lodash from 'lodash'

export default {
  components: { EditInspectionInfo, SampleImage },
  mixins: [TableAutoHeight, EditLoading],
  props: {
    inspectionCode: { type: String, default: '' },
    totalArrivalQuantity: { type: Number, default: 0 },
    totalInspectionRolls: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.v_tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => totalColumnValues[t.field] || '')
      result[2] = this.$l('INDEX.total') || '合计'
      this.setPercent(result, this.v_tableData)
      return [result]
    },
    tableColumns() {
      return tableColumns(this, this.disabled)
    },
    previewSrcs() {
      if (!this.v_imageList || !this.v_imageList.length) return []
      return this.v_imageList.map((item) => item.fileUrl)
    },
    isEmpty() {
      return !this.v_imageList || !this.v_imageList.length
    },
    checkIsEmpty() {
      return !this.checkedRow || !this.checkedRow.length
    },
    checkCount() {
      if (this.checkIsEmpty) return 0
      return this.checkedRow.length
    },
  },
  data() {
    return {
      visible: false,
      v_tableData: [],
      v_imageList: [],
      checkedRow: [],
      statementOptionalVisible: false,
      editInspectionOption: {
        inspectionVisible: false,
        disabled: false,
        data: {},
      },
      format: (number) => format(number),
    }
  },
  watch: {
    tableData: {
      handler(val) {
        this.v_tableData = lodash.cloneDeep(val)
      },
      immediate: true,
    },
  },
  methods: {
    async batchDelShare() {
      await this.batchDel(this.checkedRow)
      this.$refs.itemTable.removeCheckboxRow()
      this.checkedRow = []
      this.$emit('refresh')
    },
    async del(row) {
      await this.batchDel([row.inspectionDetailCode])
      this.$refs.itemTable.remove(row)
      this.$emit('refresh')
    },

    async batchDel(inspectionDetailCodeList) {
      this.loadingOpen()
      await this.$api
        .fabricInspectionDetailBatchDelApi({ inspectionDetailCodeList })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
            return
          }
          this.$message({
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        })
    },
    openInspectionVisible() {
      this.editInspectionOption = {
        inspectionVisible: true,
        disabled: false,
      }
    },
    openEditInspectionVisible(type, row) {
      this.editInspectionOption = {
        inspectionVisible: true,
        disabled: type === 'detail',
        inspectionDetailCode: row.inspectionDetailCode,
      }
    },

    close() {
      this.$emit('refresh')
    },
    async setTableData(data) {
      if (!data) return false
      this.editInspectionOption = {
        inspectionVisible: false,
      }
      const $itemTable = this.$refs.itemTable

      const { _X_ID } = data
      const { tableData } = await $itemTable.getTableData()
      if (!_X_ID || !tableData || !tableData.length) {
        this.v_tableData.push(data)
      } else {
        const index = tableData.findIndex((item) => item._X_ID === _X_ID)
        if (index >= 0) {
          this.v_tableData.splice(index, 1, { ...data })
        } else {
          this.v_tableData.push(data)
        }
      }
    },
    setPercent(result, inspectionDetailList) {
      if (!inspectionDetailList || inspectionDetailList.length == 0) {
        return
      }

      //检验米数
      const totalInspectQuantity = this.sumKey(
        inspectionDetailList,
        'inspectQuantity'
      )
      //疵点总计
      const totalDefectCount = this.sumKey(
        inspectionDetailList,
        'defectTotalCount'
      )

      //利用率
      const totalUtilizationRate = multiply(
        divideDown(
          subtract(totalInspectQuantity, totalDefectCount),
          totalInspectQuantity,
          4
        ),
        100
      )
      const v_totalUtilizationRate = totalUtilizationRate
        ? totalUtilizationRate + '%'
        : '0%'

      //短码率取列表前3匹（后端已按创建时间升序 + 缸批号升序返回）
      const shortRateDetailList = inspectionDetailList.slice(0, 3)
      const totalShortQuantity = this.sumKey(
        shortRateDetailList,
        'shortQuantity'
      )
      const shortRateInspectQuantity = this.sumKey(
        shortRateDetailList,
        'inspectQuantity'
      )
      //短码率
      const totalShortRate = multiply(
        divideDown(totalShortQuantity, shortRateInspectQuantity, 4),
        100
      )
      const v_totalShortRate = totalShortRate ? totalShortRate + '%' : '0%'
      //利用率
      result[11] = v_totalUtilizationRate
      //短码率
      result[14] = v_totalShortRate
    },

    sumKey(list, key) {
      if (!Array.isArray(list)) return 0
      return list.reduce((sum, item) => add(sum, Number(item?.[key]) || 0), 0)
    },

    closeImage() {
      this.visible = false
    },
    async getImageData() {
      if (!this.inspectionCode) return
      const res = await this.$api
        .inspectionDefectImageListApi({ inspectionCode: this.inspectionCode })
        .catch(() => null)
      this.v_imageList = res.body.data
    },
    async onImagePreview({ index }) {
      await this.getImageData()
      if (!this.previewSrcs || !this.previewSrcs.length) {
        this.$confirm(
          this.$l('tip_label_no_inspection_image') ||
            '还未上传码单照片，请先上传码单照片',
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
            cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
            type: 'warning',
          }
        )
        return
      }
      this.viewer = this.$el.querySelector('.imagesViewer').$viewer
      this.viewer.view(index)
      this.viewer.show()
    },
    checkboxChange({ records, reserves }) {
      const data = records.concat(reserves) || []
      this.checkedRow = data.map((item) => item.inspectionDetailCode) || []
    },
  },
}
</script>
